module.exports = __webpack_public_path__ + "static/media/yo.dbe67741.png";